const safari = navigator.userAgent.indexOf('Safari') > -1
const chrome = navigator.userAgent.indexOf('Chrome') > -1

export const detectSafari = safari && !chrome
